// This file is auto-generated by @hey-api/openapi-ts

import { client } from './client.gen';

import type { Client, Options as ClientOptions, TDataShape } from './client';
import type {
  ChatHistoryRouteChatHistoryGetData,
  ChatHistoryRouteChatHistoryGetErrors,
  ChatHistoryRouteChatHistoryGetResponses,
  ChatRouteChatGetData,
  ChatRouteChatGetErrors,
  ChatRouteChatGetResponses,
  DownloadJobFrameworkDownloadSessionIdPostData,
  DownloadJobFrameworkDownloadSessionIdPostErrors,
  DownloadJobFrameworkDownloadSessionIdPostResponses,
  GenerateFullJobFrameworkRouteJobDescriptionsSessionIdGetData,
  GenerateFullJobFrameworkRouteJobDescriptionsSessionIdGetErrors,
  GenerateFullJobFrameworkRouteJobDescriptionsSessionIdGetResponses,
  GetJobFrameworkRouteJobFrameworkSessionIdGetData,
  GetJobFrameworkRouteJobFrameworkSessionIdGetErrors,
  GetJobFrameworkRouteJobFrameworkSessionIdGetResponses,
  HealthCheckHealthcheckGetData,
  HealthCheckHealthcheckGetErrors,
  HealthCheckHealthcheckGetResponses,
  RestoreCheckpointRouteCheckpointsRestorePostData,
  RestoreCheckpointRouteCheckpointsRestorePostErrors,
  RestoreCheckpointRouteCheckpointsRestorePostResponses,
  UpdateJobFrameworkRouteJobFrameworkSessionIdPutData,
  UpdateJobFrameworkRouteJobFrameworkSessionIdPutErrors,
  UpdateJobFrameworkRouteJobFrameworkSessionIdPutResponses,
  ValidateEmailEmailValidatePostData,
  ValidateEmailEmailValidatePostErrors,
  ValidateEmailEmailValidatePostResponses,
} from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<
  TData,
  ThrowOnError
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Health Check
 */
export const healthCheckHealthcheckGet = <ThrowOnError extends boolean = false>(
  options?: Options<HealthCheckHealthcheckGetData, ThrowOnError>,
) => {
  return (options?.client ?? client()).get<
    HealthCheckHealthcheckGetResponses,
    HealthCheckHealthcheckGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/healthcheck',
    ...options,
  });
};

/**
 * Chat Route
 */
export const chatRouteChatGet = <ThrowOnError extends boolean = false>(
  options: Options<ChatRouteChatGetData, ThrowOnError>,
) => {
  return (options.client ?? client()).get<ChatRouteChatGetResponses, ChatRouteChatGetErrors, ThrowOnError>({
    url: '/chat',
    ...options,
  });
};

/**
 * Chat History Route
 */
export const chatHistoryRouteChatHistoryGet = <ThrowOnError extends boolean = false>(
  options: Options<ChatHistoryRouteChatHistoryGetData, ThrowOnError>,
) => {
  return (options.client ?? client()).get<
    ChatHistoryRouteChatHistoryGetResponses,
    ChatHistoryRouteChatHistoryGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/chat/history',
    ...options,
  });
};

/**
 * Get Job Framework Route
 * Get the job framework for a specific session.
 */
export const getJobFrameworkRouteJobFrameworkSessionIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetJobFrameworkRouteJobFrameworkSessionIdGetData, ThrowOnError>,
) => {
  return (options.client ?? client()).get<
    GetJobFrameworkRouteJobFrameworkSessionIdGetResponses,
    GetJobFrameworkRouteJobFrameworkSessionIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/job-framework/{session_id}',
    ...options,
  });
};

/**
 * Update Job Framework Route
 * Update the job framework for a specific session.
 */
export const updateJobFrameworkRouteJobFrameworkSessionIdPut = <ThrowOnError extends boolean = false>(
  options: Options<UpdateJobFrameworkRouteJobFrameworkSessionIdPutData, ThrowOnError>,
) => {
  return (options.client ?? client()).put<
    UpdateJobFrameworkRouteJobFrameworkSessionIdPutResponses,
    UpdateJobFrameworkRouteJobFrameworkSessionIdPutErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/job-framework/{session_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Generate Full Job Framework Route
 * Send the full Job Framework Structure
 */
export const generateFullJobFrameworkRouteJobDescriptionsSessionIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GenerateFullJobFrameworkRouteJobDescriptionsSessionIdGetData, ThrowOnError>,
) => {
  return (options.client ?? client()).get<
    GenerateFullJobFrameworkRouteJobDescriptionsSessionIdGetResponses,
    GenerateFullJobFrameworkRouteJobDescriptionsSessionIdGetErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/job-descriptions/{session-id}',
    ...options,
  });
};

/**
 * Restore Checkpoint Route
 * Restore the session to the specified checkpoint.
 */
export const restoreCheckpointRouteCheckpointsRestorePost = <ThrowOnError extends boolean = false>(
  options: Options<RestoreCheckpointRouteCheckpointsRestorePostData, ThrowOnError>,
) => {
  return (options.client ?? client()).post<
    RestoreCheckpointRouteCheckpointsRestorePostResponses,
    RestoreCheckpointRouteCheckpointsRestorePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/checkpoints/restore',
    ...options,
  });
};

/**
 * Validate Email
 * Validate an email address with all checks including send limits.
 */
export const validateEmailEmailValidatePost = <ThrowOnError extends boolean = false>(
  options: Options<ValidateEmailEmailValidatePostData, ThrowOnError>,
) => {
  return (options.client ?? client()).post<
    ValidateEmailEmailValidatePostResponses,
    ValidateEmailEmailValidatePostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/email/validate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};

/**
 * Download Job Framework
 */
export const downloadJobFrameworkDownloadSessionIdPost = <ThrowOnError extends boolean = false>(
  options: Options<DownloadJobFrameworkDownloadSessionIdPostData, ThrowOnError>,
) => {
  return (options.client ?? client()).post<
    DownloadJobFrameworkDownloadSessionIdPostResponses,
    DownloadJobFrameworkDownloadSessionIdPostErrors,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/download/{session_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
};
